import React from "react";

export const TwitterIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44.62"
      height="44.619"
      viewBox="0 0 44.62 44.619"
    >
      <path
        id="twitter-icon"
        fill="#D7DF23"
        d="M0 0v44.62h44.62V0H0zm33.511 16.449c-.271.2-.38.41-.38.761.02 2.91-.7 5.64-2.11 8.18-.8 1.43-1.78 2.73-2.98 3.84-2.39 2.21-5.21 3.561-8.449 3.98-2.141.27-4.271.18-6.36-.37-1.45-.391-2.83-.97-4.12-1.74-.08-.05-.16-.12-.32-.24 3.04.271 5.69-.47 8.061-2.279-1.15-.101-2.2-.46-3.12-1.16-.91-.69-1.58-1.58-1.95-2.75h2.28c.01-.04.03-.09.04-.141-1.25-.319-2.29-.97-3.07-1.96-.79-1.01-1.22-2.149-1.21-3.51.78.33 1.51.64 2.37.62-2.39-2.06-2.96-4.48-1.61-7.42 3.061 3.54 6.83 5.53 11.5 5.85-.029-.199-.04-.34-.069-.489-.511-3.61 2.55-6.74 6.17-6.311 1.24.15 2.31.65 3.229 1.5.11.11.34.16.5.13.98-.21 1.91-.55 2.79-1.029.09-.051.19-.101.29-.141.021-.01.04 0 .13 0-.43 1.22-1.17 2.16-2.21 2.95.48-.09.96-.16 1.42-.28.48-.13.94-.31 1.41-.47-.583.99-1.343 1.8-2.232 2.479z"
      />
    </svg>
  );
};
